module.exports = __webpack_public_path__ + "static/img/pranav.deaeb62.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/pranav.jpg
// module id = 494
// module chunks = 11